import {
  SLA_PROFILE_LIST, SLA_PROFILE_LIST_SUCCESS, SLA_PROFILE_LIST_FAILURE,
  SLA_PROFILE_DATA, SLA_PROFILE_DATA_SUCCESS, SLA_PROFILE_DATA_FAILURE,
  SLA_PROFILE_CREATE, SLA_PROFILE_CREATE_SUCCESS, SLA_PROFILE_CREATE_FAILURE,
  SLA_PROFILE_UPDATE, SLA_PROFILE_UPDATE_SUCCESS, SLA_PROFILE_UPDATE_FAILURE,
  SLA_PROFILE_DELETE, SLA_PROFILE_DELETE_SUCCESS, SLA_PROFILE_DELETE_FAILURE,
  SLA_METRIC_CREATE, SLA_METRIC_CREATE_SUCCESS, SLA_METRIC_CREATE_FAILURE,
  SLA_METRIC_UPDATE, SLA_METRIC_UPDATE_SUCCESS, SLA_METRIC_UPDATE_FAILURE,
  SLA_METRIC_DELETE, SLA_METRIC_DELETE_SUCCESS, SLA_METRIC_DELETE_FAILURE,
  CUSTOMER_SLA_LIST, CUSTOMER_SLA_LIST_SUCCESS, CUSTOMER_SLA_LIST_FAILURE,
  CUSTOMER_SLA_ACTIVE, CUSTOMER_SLA_ACTIVE_SUCCESS, CUSTOMER_SLA_ACTIVE_FAILURE,
  CUSTOMER_SLA_ASSIGN, CUSTOMER_SLA_ASSIGN_SUCCESS, CUSTOMER_SLA_ASSIGN_FAILURE,
  CUSTOMER_SLA_DELETE, CUSTOMER_SLA_DELETE_SUCCESS, CUSTOMER_SLA_DELETE_FAILURE,
} from "./actionType";

const initialState = {
  slaProfileList: [], slaProfileListLoading: false,
  slaProfileData: [], slaProfileDataLoading: false,
  slaProfileCreate: [], slaProfileCreateLoading: false,
  slaProfileUpdate: [], slaProfileUpdateLoading: false,
  slaProfileDelete: [], slaProfileDeleteLoading: false,
  slaMetricCreate: [], slaMetricCreateLoading: false,
  slaMetricUpdate: [], slaMetricUpdateLoading: false,
  slaMetricDelete: [], slaMetricDeleteLoading: false,
  customerSlaList: [], customerSlaListLoading: false,
  customerSlaActive: [], customerSlaActiveLoading: false,
  customerSlaAssign: [], customerSlaAssignLoading: false,
  customerSlaDelete: [], customerSlaDeleteLoading: false,
};

const Sla = (state = initialState, action) => {
  switch (action.type) {
    case SLA_PROFILE_LIST:         return { ...state, slaProfileListLoading: true };
    case SLA_PROFILE_LIST_SUCCESS: return { ...state, slaProfileList: action.payload, slaProfileListLoading: false };
    case SLA_PROFILE_LIST_FAILURE: return { ...state, slaProfileList: [], slaProfileListLoading: false };

    case SLA_PROFILE_DATA:         return { ...state, slaProfileDataLoading: true };
    case SLA_PROFILE_DATA_SUCCESS: return { ...state, slaProfileData: action.payload, slaProfileDataLoading: false };
    case SLA_PROFILE_DATA_FAILURE: return { ...state, slaProfileData: [], slaProfileDataLoading: false };

    case SLA_PROFILE_CREATE:         return { ...state, slaProfileCreateLoading: true };
    case SLA_PROFILE_CREATE_SUCCESS: return { ...state, slaProfileCreate: action.payload, slaProfileCreateLoading: false };
    case SLA_PROFILE_CREATE_FAILURE: return { ...state, slaProfileCreate: [], slaProfileCreateLoading: false };

    case SLA_PROFILE_UPDATE:         return { ...state, slaProfileUpdateLoading: true };
    case SLA_PROFILE_UPDATE_SUCCESS: return { ...state, slaProfileUpdate: action.payload, slaProfileUpdateLoading: false };
    case SLA_PROFILE_UPDATE_FAILURE: return { ...state, slaProfileUpdate: [], slaProfileUpdateLoading: false };

    case SLA_PROFILE_DELETE:         return { ...state, slaProfileDeleteLoading: true };
    case SLA_PROFILE_DELETE_SUCCESS: return { ...state, slaProfileDelete: action.payload, slaProfileDeleteLoading: false };
    case SLA_PROFILE_DELETE_FAILURE: return { ...state, slaProfileDelete: [], slaProfileDeleteLoading: false };

    case SLA_METRIC_CREATE:         return { ...state, slaMetricCreateLoading: true };
    case SLA_METRIC_CREATE_SUCCESS: return { ...state, slaMetricCreate: action.payload, slaMetricCreateLoading: false };
    case SLA_METRIC_CREATE_FAILURE: return { ...state, slaMetricCreate: [], slaMetricCreateLoading: false };

    case SLA_METRIC_UPDATE:         return { ...state, slaMetricUpdateLoading: true };
    case SLA_METRIC_UPDATE_SUCCESS: return { ...state, slaMetricUpdate: action.payload, slaMetricUpdateLoading: false };
    case SLA_METRIC_UPDATE_FAILURE: return { ...state, slaMetricUpdate: [], slaMetricUpdateLoading: false };

    case SLA_METRIC_DELETE:         return { ...state, slaMetricDeleteLoading: true };
    case SLA_METRIC_DELETE_SUCCESS: return { ...state, slaMetricDelete: action.payload, slaMetricDeleteLoading: false };
    case SLA_METRIC_DELETE_FAILURE: return { ...state, slaMetricDelete: [], slaMetricDeleteLoading: false };

    case CUSTOMER_SLA_LIST:         return { ...state, customerSlaListLoading: true };
    case CUSTOMER_SLA_LIST_SUCCESS: return { ...state, customerSlaList: action.payload, customerSlaListLoading: false };
    case CUSTOMER_SLA_LIST_FAILURE: return { ...state, customerSlaList: [], customerSlaListLoading: false };

    case CUSTOMER_SLA_ACTIVE:         return { ...state, customerSlaActiveLoading: true };
    case CUSTOMER_SLA_ACTIVE_SUCCESS: return { ...state, customerSlaActive: action.payload, customerSlaActiveLoading: false };
    case CUSTOMER_SLA_ACTIVE_FAILURE: return { ...state, customerSlaActive: [], customerSlaActiveLoading: false };

    case CUSTOMER_SLA_ASSIGN:         return { ...state, customerSlaAssignLoading: true };
    case CUSTOMER_SLA_ASSIGN_SUCCESS: return { ...state, customerSlaAssign: action.payload, customerSlaAssignLoading: false };
    case CUSTOMER_SLA_ASSIGN_FAILURE: return { ...state, customerSlaAssign: [], customerSlaAssignLoading: false };

    case CUSTOMER_SLA_DELETE:         return { ...state, customerSlaDeleteLoading: true };
    case CUSTOMER_SLA_DELETE_SUCCESS: return { ...state, customerSlaDelete: action.payload, customerSlaDeleteLoading: false };
    case CUSTOMER_SLA_DELETE_FAILURE: return { ...state, customerSlaDelete: [], customerSlaDeleteLoading: false };

    default: return state;
  }
};

export default Sla;
